<svelte:options tag={null} />
<script lang="typescript">
  import { onMount } from "svelte/internal";
  import "@everymatrix/em-card/dist/em-card";

  import { currencySymbol, formatNumbers } from '@everymatrix/retail-helpers';

	export let src: string = null;
  export let playerid: string = null;
  export let isexpandable: string = 'false';
  export let expandicon: string = 'false';
  let openContent: boolean = false;

  let bettingInfo: any;
  let authHeaders: any;
  let isLoading: boolean = false;
  let currency: string;

  const fetchBettingInfo = async (src: string, headers: any) => {
    try {
      isLoading = true;
      const res = await fetch(src, { headers: {...headers} });
      const data = await res.json();
      isLoading = false;
      if (res.ok) {
        bettingInfo = { ...data };
      }
    } catch (err) {
      isLoading = false;
      throw new Error(`err: ${err}`);
    }
  }

  const handleEvents = (e) => {
    e.data?.type === "SetAuthHeaders" && 
      JSON.stringify(authHeaders) !== JSON.stringify(e.data.payload) && 
      (authHeaders = {...e.data.payload})
    ;
  }

  const fetchPlayerCurrency = async (src: string, headers: any) => {
    try {
      const res = await fetch(src, { headers: { ...headers } });
      const data = await res.json();
      if (res.ok) {
        currency = data.currency;
      }
    } catch (err) {
      throw new Error(`err:${err}`);
    }
  };

  onMount(() => {
    window.postMessage({ type: "GetAuthHeaders" }, "*");
    window.addEventListener("message", handleEvents);

    return () => {
      window.removeEventListener("message", handleEvents);
    }
  });

  $: src && authHeaders && playerid && fetchBettingInfo(`${src}${playerid}/transactions/sports/summary`, { ...authHeaders });
  $: src &&
    playerid &&
    authHeaders &&
    fetchPlayerCurrency(`${src}${playerid}/profile`, { ...authHeaders });
</script>


<em-card class="card">
  <!-- Header -->
  <div
    class="row header"
    slot="header" 
    on:click={() => {
      if(isexpandable === 'true') {
        openContent = !openContent;
      }
    }}
  >
  <h3>
    Betting Info
  </h3>
  {#if expandicon === 'true'}
    <svg
      class="header_icon {openContent ? 'active' : ''}"
      fill="currentColor" 
      viewBox="0 0 20 20" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
    </svg>
  {/if}
  </div>
  

  <!-- Content -->
  <div slot="content">
  {#if bettingInfo}
    <ul>
      {#if isexpandable === 'true' && !openContent}
        <li>
          <strong>Total Turnover(Real):</strong>
          <span>
            {formatNumbers(parseFloat(bettingInfo.totalBetReal))} {currencySymbol(currency)}
          </span>
        </li>
      {:else}
        <li>
          <strong>Total Turnover(Real):</strong>
          <span>
            {formatNumbers(parseFloat(bettingInfo.totalBetReal))} {currencySymbol(currency)}
          </span>
        </li>
        <li>
          <strong>Total Payout(Real):</strong>
          <span>
            {formatNumbers(parseFloat(bettingInfo.totalWinReal))} {currencySymbol(currency)}
          </span>
        </li>
        <li>
          <strong>Total Turnover(Bonus):</strong>
          <span>
            {formatNumbers(parseFloat(bettingInfo.totalBetBonus))} {currencySymbol(currency)}
          </span>
        </li>
        <li>
          <strong>Total Payout(Bonus):</strong>
          <span>
            {formatNumbers(parseFloat(bettingInfo.totalWinBonus))} {currencySymbol(currency)}
          </span>
        </li>
        <li>
          <strong>Last Bet Date:</strong>
          <span>
            {bettingInfo.lastBetDate
              ? bettingInfo.lastBetDate.split(".")[0] + " GMT"
              : "N/A"}
          </span>
        </li>
      {/if}
     
    </ul>
  {:else if isLoading}
    <ul class="loader">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  {:else}
    <li>
      <p style="color: #cc2127;">Failed to fetch betting info</p>
    </li>
  {/if}
  </div>
</em-card>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }

  li {
    display: grid;
    grid-template-columns: auto 1fr;
    margin-bottom: 10px;
    &:last-child { margin-bottom: 0; }

    strong {
      margin-right: 10px;
    }

    span {
      align-self: flex-end;
    }
  }

  .row{
    display:flex;
    flex-direction: row;
  }
  .header_icon { 
    width: 20px; 
    height: 20px; 
  }
  .header_icon.active { transform: rotate(180deg); }

  // Text Loader
  .loader {
    min-width: 200px;

    li {
      position: relative;
      height: 18px;
      margin-bottom: 10px;
      animation-duration: 1.25s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: shimmer;
      animation-timing-function: linear;
      background: #F6F6F6;
      background: linear-gradient(to right, #F6F6F6 8%, #F0F0F0 18%, #f5f5f5 33%);
      background-size: 800px 104px;
      &:last-child { margin-bottom: 0; }
    }
  }
  // Animation
  @keyframes shimmer{
    0%{
      background-position: -468px 0
    }
    100%{
      background-position: 468px 0
    }
  }
</style>
